import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit'
import { RootState } from '@reduxjs/toolkit/dist/query/core/apiState'
import { removeCaseError } from '../store/manage/agenda'
import { getCaseError } from '../store/manage/agenda/selector'

interface ILifeCycleProps {
  getState?: (() => RootState<any, any, 'api'>) | (() => unknown)
  dispatch?: ThunkDispatch<any, any, AnyAction>
}

export const removeCaseErrorIfExists = (
  caseId: string,
  { getState, dispatch }: ILifeCycleProps
) => {
  const state = getState?.()
  const error = getCaseError(caseId)(state)

  if (!error) return

  dispatch?.(removeCaseError(caseId))
}
